// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getCustomBadge } from "@awc/App/Store/Selectors/ProductSelectors";
import Badge, { BadgePresentationProps, BadgeTypeValues } from "@awc/MobiusOverrides/Badge/Badge";
import { getSystemColor, mergeWithCss, sharedBadgeStyle } from "@awc/XDL/Utilities";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import React, { useState } from "react";

export type CustomProductBadgeStyle = Pick<BadgePresentationProps, "textBadgeCss" | "textBadgeWrapperCss">;

interface OwnProps {
    product?: ProductModel;
    extendedStyles?: CustomProductBadgeStyle;
}

export const customProductBadgeStyles: CustomProductBadgeStyle = {
    textBadgeCss: {
        ...sharedBadgeStyle.badgeText,
    },
    textBadgeWrapperCss: {
        ...sharedBadgeStyle.badge,
    },
};

const CustomProductBadge = ({ product, extendedStyles }: OwnProps) => {
    const [styles] = useState(() => mergeWithCss(customProductBadgeStyles, extendedStyles));

    if (!product) {
        return null;
    }

    const customBadge = getCustomBadge(product);

    if (!customBadge) {
        return null;
    }

    return (
        <Badge
            type={BadgeTypeValues.Text}
            value={customBadge}
            badgeBackgroundColor={getSystemColor("secondary", 1, true).replace("#", "")}
            badgeTextColor={getSystemColor("common.ui7", 1, true).replace("#", "")}
            {...styles}
        />
    );
};

export default CustomProductBadge;
